import React from 'react';
import clsx from 'clsx';
import { ExtractedAriaRoleBy } from '../wcag/tools/wcag.model';
import { FontSizeType } from 'common-react';
import { TypographyFontWeightModel } from '../Typography/tools/Typography.model';

import useStyles from './Label.style';

export interface LabelProps {
  size?: FontSizeType;
  fontWeight?: TypographyFontWeightModel;
  className?: string;
  color?: 'dark' | 'graphite';
  lang?: string;
  as?: keyof JSX.IntrinsicElements;
  htmlFor?: string;
  id?: string;
  role?: ExtractedAriaRoleBy<'columnheader'>;
  hasBottomMargin?: boolean;
}

const Label: React.FC<LabelProps> = ({
  children,
  size = "s",
  fontWeight = 'normal',
  className,
  color = 'dark',
  lang,
  as: Component = 'span',
  id,
  htmlFor,
  role,
  hasBottomMargin = false,
}) => {
  const c = useStyles({ size, fontWeight, color, hasBottomMargin });
  const setHtmlForWhenLabelComponent = Component === 'label' ? { htmlFor } : {};
  return (
    <Component
      className={clsx(c.root, className)}
      lang={lang}
      id={id}
      {...setHtmlForWhenLabelComponent}
      role={role}
    >
      {children}
    </Component>
  );
};

export { Label };
